'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserAuthWrapper = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _factory = require('./factory');

var _factory2 = _interopRequireDefault(_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserAuthWrapper = exports.UserAuthWrapper = (0, _factory2.default)(_react2.default, 'div');


//////////////////
// WEBPACK FOOTER
// ./~/redux-auth-wrapper/lib/index.js
// module id = 1378
// module chunks = 0